export default "__VITE_ASSET__qhGfjr_$__"